import { colors, scale } from '@scripts/gds';

import ArrowRightIcon from '@icons/24/chevrone-right.svg';

const Separator = () => (
    <span
        css={{
            margin: `0 ${scale(1, false, 3)}px`,
            display: 'flex',
            alignItems: 'center',
            fill: colors.textSecondGrey,
        }}
    >
        <ArrowRightIcon />
    </span>
);

export default Separator;
